import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

interface UnderConstructionProps {
  title: string;
  subtitle?: string;
}

export default function UnderConstruction({ title, subtitle }: UnderConstructionProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16 px-4">
        <div className="max-w-3xl mx-auto text-center py-20">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-tools-line text-3xl text-primary-600"></i>
          </div>
          <h1 className="mt-6 text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-foreground-600">{subtitle}</p>
          )}
          <p className="mt-6 text-sm text-foreground-500">
            このページは現在作成中です。まもなく公開します。
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}